export const EVENT_CATEGORY_OTHER = 0;
export const EVENT_CATEGORY_GYM = 1;
export const EVENT_CATEGORY_HIKE = 2;
export const MICROSITE_URL_PROPS = [
  'websiteUrl', 'facebookLink', 'twitterUsername', 'instagramUsername',
];
